import { render, staticRenderFns } from "./ClientAccountRowActions.vue?vue&type=template&id=3e365e94"
import script from "./ClientAccountRowActions.vue?vue&type=script&lang=js"
export * from "./ClientAccountRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports